import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { ErrorService } from "./errors.service";
@Injectable({ providedIn: "root" })
export class InterceptorService implements HttpInterceptor {
  constructor(private errorService: ErrorService) {}

  public intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(catchError(this.handleError.bind(this)));
  }

  private handleError(error: HttpErrorResponse) {
    if (error.status !== 404) {
      this.errorService.logError(
        error.message,
        "Un erreur est survenue sur le serveur. Veuillez réessayer plus tard.",
      );
    }
    return throwError(error);
  }
}
